function Title() {
  return (
    <div className="site-title">
      <span className="site-title__mark">W</span>
      <span className="site-title__copy">
        <strong>W Advokatbyrå</strong>
        <span>Affärsjuridik i Malmö</span>
      </span>
    </div>
  );
}

export default Title;
